import { FCX } from '@datassential/platform-ui-lib';
import GroupedMultiSelect from '@components/new/GroupedMultiSelect/GroupedMultiSelect';
import { useOpeningsClosingsFilters } from './context/OpeningsClosingsFilterContext';
import './OpeningsClosingsFilters.scss';

const OpeningsClosingsFilters: FCX = () => {
    const { filterGroups, selectedIds, setSelectedIds } = useOpeningsClosingsFilters();

    return (
        <div className="OpeningsClosingsFilters">
            <GroupedMultiSelect
                value={selectedIds}
                setValue={setSelectedIds}
                groups={filterGroups}
                placeholder="Select Filters"
                unitLabel="Filters"
            />
        </div>
    );
};

export default OpeningsClosingsFilters;
